<template>
  <div class="grid-x toolbar topbar" v-show="!isPageLoading" :style="{ 'background-color': avantiEnv === 'staging' ? 'rgb(160 183 206)' : '#fff' }">
    <a class="nav-button" @click="toogleMobileMenu()" href="javascript:;"><span class="hamburger"></span></a>

    <div class="cell auto">
      <TheSearchObjectTopbar v-if="$route.name === 'SearchObject'"/>
      <TheSearchCustomerTopbar v-else-if="$route.name === 'SearchCustomer'"/>
      <TheForhandsbudTopbar v-else-if="$route.name === 'Forhandsbud'"/>
      <TheSpaderTopbar v-else-if="$route.name === 'Spader'"/>
      <TheTelefonbudTopbar v-else-if="$route.name === 'Telefonbud'"/>
      <TheTilslagsskjermbildeTopbar v-else-if="$route.name === 'Tilslagsskjermbilde'"/>
      <TheMainSearch v-else/>
    </div>

    <div class="cell shrink">
      <div class="grid-x">
        <div class="user-profile-nav has-popover" :class="{'popover-active': popoverActive}" @click="togglePopover()">
          <span class="avatar" :class="strToAvatarClass(user.initials)">{{user.initials}}</span>
          <span class="user-profile-info">
            <span class="user-profile-name">{{user.full_name}}</span>
            <span class="user-profile-title">
              {{user.rolle ? user.rolle.name : '-'}}
              <span v-if="avantiEnv === 'local'">[Local]</span>
              <span v-if="avantiEnv === 'staging'">[Staging]</span>
            </span>
          </span>

          <span class="popover align-x-center align-y-bottom small">
            <ul>
              <li><a href="javascript:;" @click="openProfileModal()"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-person"></use></svg> <span>Kontoinnstillinger</span></a></li>
              <li><a href="javascript:;" @click="logout()"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-logout"></use></svg> <span>Logg ut</span></a></li>
            </ul>
          </span>
        </div>

        <div class="v-divider"></div>

        <a href="#" class="notifications-button">
          <span class="notifications-count" v-if="false"></span>
          <svg width="18px" height="19px" viewBox="0 0 18 19"><use xlink:href="/static/sprites.svg#notifications"></use></svg>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import TheMainSearch from './TheMainSearch'
import TheSearchObjectTopbar from './Search/TheSearchObjectTopbar'
import TheSearchCustomerTopbar from './Search/TheSearchCustomerTopbar'
import TheForhandsbudTopbar from './Auctions/Forhandsbud/TheTopbar'
import TheSpaderTopbar from './Auctions/Spader/TheTopbar'
import TheTelefonbudTopbar from './Auctions/Telefonbud/TheTopbar'
import TheTilslagsskjermbildeTopbar from './Auctions/Tilslagsskjermbilde/TheTopbar'

import { AUTH_LOGOUT } from '../../store/actions/auth'
import { mapGetters } from 'vuex'

export default {
  name: 'TheMainToolbar',
  components: {
    TheMainSearch,
    TheSearchObjectTopbar,
    TheSearchCustomerTopbar,
    TheForhandsbudTopbar,
    TheSpaderTopbar,
    TheTelefonbudTopbar,
    TheTilslagsskjermbildeTopbar
  },
  data () {
    return {
      user: {},
      popoverActive: false
    }
  },
  created () {
    this.user = this.getUser

    var vm = this

    window.jQuery(document).mouseup(function (e) {
      var container = window.jQuery('.has-popover')
      // if the target of the click isn't the container nor a descendant of the container
      if (!container.is(e.target) && container.has(e.target).length === 0) {
        vm.popoverActive = false
      }
    })
  },
  methods: {
    toogleMobileMenu: function () {
      // Close is in AdminLayout
      window.jQuery('body').toggleClass('nav-open')
    },
    togglePopover: function () {
      this.popoverActive = !this.popoverActive
    },
    logout: function () {
      this.$store.dispatch(AUTH_LOGOUT).then(() => this.$router.push('/'))
    },
    openProfileModal: function () {
      this.openModal(
        'user-profile-modal'
      )
    }
  },
  computed: {
    ...mapGetters(['isPageLoading', 'isLoggedIn', 'getUser'])
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/TheMainToolbar.vue